import { jsx } from 'react/jsx-runtime';
import { useCallback, useMemo } from 'react';
import { RadioGroup } from '../../Radio/Radio.Group/Radio.Group.es.js';
import { FilterGroupContent } from '../FilterGroup.Content/FilterGroup.Content.es.js';
import { useFilterGroup } from '../FilterGroup.Context/index.es.js';

const FilterRadioGroup = ({ name, children, onChange, self, ...props })=>{
    const { filters, setFilter } = useFilterGroup();
    const handleChange = useCallback((item)=>{
        setFilter(name, item, self);
        if (item !== undefined) {
            onChange?.(item);
        }
    }, [
        name,
        onChange,
        self,
        setFilter
    ]);
    const value = useMemo(()=>{
        return name in filters && typeof filters[name] !== 'object' ? String(filters[name]) : '';
    }, [
        name,
        filters
    ]);
    return jsx(FilterGroupContent, {
        classNames: "radio-group-filter-group-content",
        id: name,
        children: jsx(RadioGroup, {
            ...props,
            "data-testid": `filter-group-radiogroup-${name}`,
            direction: "vertical",
            name: name,
            onChange: handleChange,
            value: value,
            children: children
        })
    });
};
FilterRadioGroup.displayName = 'FilterGroup.Filters.RadioGroup';

export { FilterRadioGroup };
//# sourceMappingURL=FilterGroup.RadioGroup.es.js.map
